import { createContext, useContext, useEffect, useState } from "react";
import { api, apiErr } from "./api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = guest, obj = user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("cc_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => {
        localStorage.removeItem("cc_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("cc_token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiErr(e.response?.data?.detail) || e.message };
    }
  };

  const signup = async (name, email, password, acceptedTerms) => {
    try {
      const { data } = await api.post("/auth/register", { name, email, password, accepted_terms: !!acceptedTerms });
      localStorage.setItem("cc_token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiErr(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    localStorage.removeItem("cc_token");
    setUser(false);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, signup, logout, setUser, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};
